'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _About = require('./About.css');

var _About2 = _interopRequireDefault(_About);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var About = (_dec = (0, _reactCssModules2.default)(_About2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(About, _Component);

  function About(props) {
    (0, _classCallCheck3.default)(this, About);

    var _this = (0, _possibleConstructorReturn3.default)(this, (About.__proto__ || (0, _getPrototypeOf2.default)(About)).call(this, props));

    _this.state = {
      title: 'About us',
      description: 'As You Sow is the nation’s non-profit leader in shareholder advocacy. Founded in 1992, we harness shareholder power to create lasting change that benefits people, planet, and profit.',
      url: _config2.default.domain + _config2.default.routes.about
    };
    return _this;
  }

  (0, _createClass3.default)(About, [{
    key: 'render',
    value: function render() {
      var aysIcon = require('../../../static/images/AsYouSow_Logo_color.svg');
      var charityNavigatorIcon = require('../../../static/images/charity-navigator.jpg');
      //
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _container2.default.helmet(this.state.title, this.state.description, this.state.url),
          _react2.default.createElement(
            'div',
            { styleName: 'about-banner' },
            _react2.default.createElement(
              _components.ContainerDivs,
              null,
              _react2.default.createElement(
                'h1',
                { styleName: 'title' },
                'About us'
              )
            )
          ),
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'div',
              { styleName: 'answer' },
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    'Employer-offered retirement plans are directing hundreds of billions of dollars of employee savings into unsustainable investments, which carry real financial risks.'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'It\'s time for employer-offered retirement plans to start taking responsibility for their role in fueling climate change and other sustainability issues, so savers have a future they can retire into. That\'s why we created the retirement plan sustainability scorecard.'
                )
              ),
              _react2.default.createElement(
                'h2',
                null,
                _react2.default.createElement(
                  _components.SrOnly,
                  null,
                  'As You Sow'
                ),
                _react2.default.createElement('img', {
                  src: aysIcon,
                  alt: 'As You Sow',
                  styleName: 'ays-logo'
                })
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'i',
                    null,
                    'As You Sow'
                  ),
                  ' is the nation\u2019s non-profit leader in shareholder advocacy. Founded in 1992, we harness shareholder power to create lasting change that benefits people, planet, and profit. Learn more about us at ',
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.links.ays,
                      title: 'As You Sow',
                      xstrong: true
                    },
                    'asyousow.org'
                  ),
                  '.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Our mission'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Our mission is to promote environmental and social corporate responsibility through shareholder advocacy, coalition building, and innovative legal strategies.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Our vision'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Our vision is a safe, just, and sustainable world in which protecting the environment and human rights is central to corporate decision making.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement('img', {
                    src: charityNavigatorIcon,
                    alt: 'As You Sow is rated as a 4-star charity by Charity Navigator'
                  })
                )
              ),
              _react2.default.createElement(
                'h2',
                null,
                'Fossil Free Funds'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Since 2015, ',
                  _react2.default.createElement(
                    'i',
                    null,
                    'As You Sow'
                  ),
                  '\u2019s Fossil Free Funds has been analyzing the holdings of mutual funds and rating them on fossil fuel investments and overall carbon footprint. We\u2019ve since expanded our sustainability analysis to include deforestation, as well as social issues like gender equality, civilian firearms, the prison industrial complex, arms manufacturers and military contractors, and tobacco. Learn more about Fossil Free Funds at ',
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.links.fff,
                      title: 'Fossil Free Funds',
                      xstrong: true
                    },
                    'fossilfreefunds.org',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              ),
              _react2.default.createElement(
                'h2',
                null,
                'Invest Your Values'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Our newest effort is ',
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.home,
                      title: 'Invest Your Values',
                      xstrong: true
                    },
                    'investyourvalues.org'
                  ),
                  ' - applying our sustainability scorecard to the retirement plans of major publicly-traded companies. Right now, we have a small number of company retirement plans rated, but we\'ll be adding more throughout the year, with the goal of rating the retirement plans of every company in the S&P 500.'
                )
              )
            )
          )
        ),
        _react2.default.createElement(_components.RetirementPlanList, null),
        _react2.default.createElement(_components.IyvBanner, { hideLink: true })
      );
    }
  }]);
  return About;
}(_react.Component)) || _class);
exports.default = About;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/About/About.js
// module id = 1456
// module chunks = 0